`<template>
  <div
    class="modal fade"
    id="serverErrorModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="serverErrorModal"
    aria-hidden="true"
    data-backdrop="static" data-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            {{ $t("confirmation.box.title") }}
          </h3>
        </div>
        <div class="modal-body">
          <b>{{ $t(this.messageText) }}</b>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="ok()">
            {{ $t("btn.ok") }}
          </button>
          <button class="btn btn-warning" @click="cancel()">
            {{ $t("btn.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import $ from "jquery";

export default {
    name: "ServerErrorModal",
    data() {
        return {
            OK: "ok",
            CANCEL: "cancel",
            messageText: null
        }
    },
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_SERVER_ERROR_MODAL, (params) => {
            this.show(params);
        });
    },
    methods: {
        show(params) {
            this.messageText = params.messageText;
            $("#serverErrorModal").modal("show");
        },
        cancel() {
            $("#serverErrorModal").modal("hide");
        },
        ok() {
            $("#serverErrorModal").modal("hide");
            this.$modal.closeServerErrorModal(this.OK);
        }
    },
};
</script>

<style scoped>
  .modal-dialog {
    max-width: 600px;
  }
</style>
